(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivelle-celebrity-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vivelle-spotlight')) {
    customElements.define('vivelle-spotlight', class VivelleSpotlight extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-track]');
        this.rail = this.querySelector('[data-rail]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        if (!this.track || !this.rail || !this.cards.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.nativeOverflowFallback = !CSS.supports('overflow', 'clip');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplayAttemptedIndex = null;
        this.activeIndex = Math.min(Number(this.dataset.start) || 0, this.cards.length - 1);
        this.status = this.querySelector('[data-status]');
        this.counter = this.querySelector('[data-current]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.playRequests = new WeakMap();
        this.buildLoop();
        this.resolveCanonical(this.activeIndex, false);
        this.setAttribute('data-ready', '');

        this.querySelector('[data-previous]')?.addEventListener('click', () => this.moveBy(-1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.moveBy(1), options);
        this.dots.forEach(dot => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot)), options));
        this.track.addEventListener('pointerdown', event => this.pointerDown(event), options);
        document.addEventListener('pointermove', event => this.pointerMove(event), options);
        document.addEventListener('pointerup', event => this.pointerUp(event), options);
        document.addEventListener('pointercancel', event => this.pointerUp(event, true), options);
        // Capture can be transferred or released while the finger is still down.
        // Document listeners keep the drag alive until pointerup or pointercancel.
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('click', event => {
          if (event.detail !== 0 && performance.now() < (this.suppressClickUntil || 0)) {
            this.suppressClickUntil = 0;
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          const button = event.target.closest('[data-play]');
          if (button) {
            event.preventDefault();
            this.playCard(Number(button.closest('[data-card]').dataset.slideIndex));
            return;
          }
          // Copies are inert decoration. A tap on their drawn play circle resolves
          // directly to the one real video without creating another media element.
          const proxy = Array.from(this.rail.querySelectorAll('[data-play-proxy]')).find(element => {
            const rect = element.getBoundingClientRect();
            return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
          });
          if (proxy) {
            event.preventDefault();
            this.playCard(Number(proxy.closest('[data-loop-copy]').dataset.slideIndex));
          }
        }, { ...options, capture: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const keys = {
            ArrowRight: this.direction, ArrowLeft: -this.direction,
            Home: 'first', End: 'last'
          };
          if (!(event.key in keys)) return;
          event.preventDefault();
          if (keys[event.key] === 'first') this.goTo(0);
          else if (keys[event.key] === 'last') this.goTo(this.cards.length - 1);
          else this.moveBy(keys[event.key]);
        }, options);
        this.track.addEventListener('focusin', event => {
          const card = event.target.closest('[data-card]');
          if (card && card !== this.cards[this.activeIndex] && !this.gesture) {
            this.goTo(Number(card.dataset.slideIndex), 'instant');
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.goTo(index, 'instant');
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.cancelGesture();
            this.resolveCanonical(this.activeIndex, false, false);
            this.autoplayAttemptedIndex = null;
            this.pauseVideos();
          } else this.updateVisibility();
        }, options);
        document.addEventListener('vivelle:spotlight:play', event => this.pauseVideos(event.detail.video), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches && !this.gesture) this.resolveCanonical(this.activeIndex, false);
        }, options);

        this.lastWidth = this.track.clientWidth;
        this.resizeObserver = new ResizeObserver(() => {
          if (this.track.clientWidth === this.lastWidth) return;
          this.lastWidth = this.track.clientWidth;
          this.cancelGesture();
          this.stopAnimation();
          this.buildLoop();
          this.resolveCanonical(this.activeIndex, false);
        });
        this.resizeObserver.observe(this.track);
        this.visibilityObserver = new IntersectionObserver(() => this.updateVisibility(), { threshold: [0, .25, .5, .75, 1] });
        this.visibilityObserver.observe(this.track);
        const visibilityChanged = () => {
          cancelAnimationFrame(this.visibilityFrame);
          this.visibilityFrame = requestAnimationFrame(() => this.updateVisibility());
        };
        window.addEventListener('scroll', visibilityChanged, { ...options, passive: true });
        window.addEventListener('resize', visibilityChanged, { ...options, passive: true });
        this.updateVisibility();
      }

      buildLoop() {
        this.rail.querySelectorAll('[data-loop-copy]').forEach(copy => copy.remove());
        this.direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.cards.forEach((card, index) => { card.dataset.slideIndex = index; });
        const width = this.cards[0].getBoundingClientRect().width;
        this.step = width * .88 + 16;
        this.buffer = this.cards.length > 1 ? Math.max(this.cards.length, Math.ceil(this.track.clientWidth / this.step) + 1) : 0;
        if (this.buffer) {
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          for (let i = 0; i < this.buffer; i++) {
            before.append(this.makeCopy(i - this.buffer));
            after.append(this.makeCopy(i));
          }
          this.rail.prepend(before);
          this.rail.append(after);
        }
        this.slides = Array.from(this.rail.children);
      }

      normalize(index) {
        return ((index % this.cards.length) + this.cards.length) % this.cards.length;
      }

      makeCopy(index) {
        const copy = this.cards[this.normalize(index)].cloneNode(true);
        copy.removeAttribute('data-card');
        copy.removeAttribute('data-block-id');
        copy.setAttribute('data-loop-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        [copy, ...copy.querySelectorAll('*')].forEach(element => {
          element.removeAttribute('id');
          Array.from(element.attributes).forEach(attribute => {
            if (attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
          });
        });
        copy.querySelectorAll('[data-media], [data-video-template], [data-error], noscript').forEach(element => element.remove());
        copy.querySelector('.vvs__card').classList.remove('has-video', 'has-frame', 'is-loading', 'is-playing');
        copy.querySelector('.vvs__card').removeAttribute('aria-busy');
        copy.querySelectorAll('a, button').forEach(element => {
          const decoration = document.createElement('span');
          decoration.className = element.className;
          decoration.innerHTML = element.innerHTML;
          if (element.hasAttribute('data-play')) decoration.setAttribute('data-play-proxy', '');
          element.replaceWith(decoration);
        });
        copy.querySelectorAll('[tabindex]').forEach(element => element.removeAttribute('tabindex'));
        return copy;
      }

      renderPosition() {
        this.rail.style.transform = `translate3d(${-this.direction * this.position * this.step}px, 0, 0)`;
        // The hidden-overflow fallback can be scrolled by keyboard focus in
        // older browsers. Only the rail transform may own horizontal position.
        if (this.nativeOverflowFallback) {
          this.track.scrollLeft = 0;
          this.scrollLeft = 0;
        }
      }

      stopAnimation() {
        cancelAnimationFrame(this.animationFrame);
        this.animation = null;
        this.targetPosition = null;
      }

      resolveCanonical(index = this.activeIndex, announce = true, allowAutoplay = true) {
        this.stopAnimation();
        this.classList.add('is-repositioning');
        this.position = this.buffer + this.normalize(index);
        this.setActive(this.normalize(index), announce, this.cards[this.normalize(index)]);
        this.renderPosition();
        // Commit both the rail and enlarged card together, without a second
        // animation or a browser scroll-snap decision at the loop boundary.
        void this.rail.offsetWidth;
        this.classList.remove('is-repositioning');
        if (allowAutoplay && this.hasAttribute('data-ready')) this.updateVisibility();
      }

      animateTo(position, announce = true, instant = false) {
        this.stopAnimation();
        const destination = Math.max(0, Math.min(position, this.slides.length - 1));
        const index = Number(this.slides[destination].dataset.slideIndex);
        this.setActive(index, announce, this.slides[destination]);
        if (instant || this.motion.matches || Math.abs(destination - this.position) < .001) {
          this.resolveCanonical(index, false);
          return;
        }
        this.targetPosition = destination;
        const animation = { from: this.position, to: destination, started: performance.now() };
        this.animation = animation;
        const tick = now => {
          if (this.animation !== animation || !this.isConnected) return;
          const progress = Math.min(1, (now - animation.started) / 300);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.position = animation.from + (animation.to - animation.from) * eased;
          this.renderPosition();
          if (progress < 1) this.animationFrame = requestAnimationFrame(tick);
          else this.resolveCanonical(index, false);
        };
        this.animationFrame = requestAnimationFrame(tick);
      }

      goTo(index, behavior, announce = true) {
        this.cancelGesture();
        const next = this.normalize(index);
        if (behavior === 'instant') {
          this.resolveCanonical(next, announce);
          return;
        }
        const from = this.targetPosition ?? this.position;
        const candidates = this.slides.map((slide, position) => ({ slide, position })).filter(item => Number(item.slide.dataset.slideIndex) === next);
        const destination = candidates.reduce((nearest, item) => Math.abs(item.position - from) < Math.abs(nearest.position - from) ? item : nearest).position;
        this.animateTo(destination, announce);
      }

      moveBy(step) {
        if (this.cards.length < 2) return;
        this.cancelGesture();
        let from = this.targetPosition ?? Math.round(this.position);
        if (from + step < 0 || from + step >= this.slides.length) {
          this.resolveCanonical(this.activeIndex, false);
          from = this.position;
        }
        this.animateTo(from + step);
      }

      setActive(index, announce = true, centered = this.cards[index]) {
        const changed = index !== this.activeIndex;
        this.activeIndex = index;
        this.slides.forEach(slide => {
          slide.classList.toggle('is-active', slide === this.cards[index]);
          slide.classList.toggle('is-centered', slide === centered);
        });
        if (changed) {
          this.autoplayAttemptedIndex = null;
          this.pauseVideos(this.cards[index].querySelector('video'));
        }
        this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
        if (this.counter) this.counter.textContent = String(index + 1);
        if (announce && this.status) this.status.textContent = this.cards[index].getAttribute('aria-label');
      }

      pointerDown(event) {
        if (this.cards.length < 2 || event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
        if (this.gesture) return;
        this.suppressClickUntil = 0;
        const video = event.target.closest('video');
        if (video && event.clientY >= video.getBoundingClientRect().bottom - 64) return;
        const resumeTarget = this.targetPosition;
        this.stopAnimation();
        this.gesture = {
          id: event.pointerId, x: event.clientX, y: event.clientY,
          position: this.position, resumeTarget, axis: null,
          lastX: event.clientX, lastTime: performance.now(), velocity: 0
        };
      }

      pointerMove(event) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (!gesture.axis) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (gesture.axis === 'x') {
            this.track.classList.add('is-dragging');
            this.autoplayAttemptedIndex = null;
            this.pauseVideos();
            this.track.setPointerCapture(event.pointerId);
          }
        }
        if (gesture.axis !== 'x') return;
        if (event.cancelable) event.preventDefault();
        const now = performance.now();
        const elapsed = now - gesture.lastTime;
        if (elapsed > 0) gesture.velocity = (event.clientX - gesture.lastX) / elapsed;
        gesture.lastX = event.clientX;
        gesture.lastTime = now;
        this.position = Math.max(0, Math.min(this.slides.length - 1, gesture.position - this.direction * dx / this.step));
        this.renderPosition();
      }

      pointerUp(event, cancelled = false) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        const horizontal = gesture.axis === 'x';
        this.cancelGesture();
        if (!horizontal) {
          if (gesture.resumeTarget !== null) this.animateTo(gesture.resumeTarget, false);
          return;
        }
        this.suppressClickUntil = performance.now() + 500;
        // Cancellation coordinates can be stale or zero. Keep the progress
        // already drawn under the finger instead of rolling back a clear swipe.
        const dx = (cancelled ? gesture.lastX : event.clientX) - gesture.x;
        const base = Math.round(gesture.position);
        let destination = Math.round(this.position);
        const flick = !cancelled && performance.now() - gesture.lastTime < 100 && Math.abs(gesture.velocity) > .35 && Math.abs(dx) > 12;
        if (destination === base && (Math.abs(dx) >= Math.min(32, this.step * .1) || flick)) {
          destination = base + Math.sign(-this.direction * dx);
        }
        this.animateTo(destination);
      }

      cancelGesture() {
        const gesture = this.gesture;
        this.gesture = null;
        this.track?.classList.remove('is-dragging');
        if (gesture && this.track.hasPointerCapture(gesture.id)) this.track.releasePointerCapture(gesture.id);
      }

      selectedVideoVisible(minimum = .5) {
        if (document.hidden || !this.isConnected) return false;
        const card = this.cards[this.activeIndex].querySelector('.vvs__card').getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        const width = Math.max(0, Math.min(card.right, track.right, window.innerWidth) - Math.max(card.left, track.left, 0));
        const height = Math.max(0, Math.min(card.bottom, track.bottom, window.innerHeight) - Math.max(card.top, track.top, 0));
        return card.width > 0 && card.height > 0 && width * height >= card.width * card.height * minimum;
      }

      updateVisibility() {
        if (!this.controller) return;
        // Separate start and stop thresholds prevent tiny viewport changes
        // near the halfway point from repeatedly pausing and restarting media.
        if (!this.selectedVideoVisible(.05)) {
          this.autoplayAttemptedIndex = null;
          this.pauseVideos();
          return;
        }
        if (!this.selectedVideoVisible() || this.animation || this.gesture) return;
        const video = this.ensureVideo(this.activeIndex);
        if (!video || !this.autoplayEnabled || this.autoplayAttemptedIndex === this.activeIndex) return;
        this.autoplayAttemptedIndex = this.activeIndex;
        if (video.paused) this.playCard(this.activeIndex, true);
      }

      ensureVideo(index) {
        const slide = this.cards[this.normalize(index)];
        const card = slide.querySelector('.vvs__card');
        const existing = card.querySelector('video');
        if (existing) return existing;
        const template = card.querySelector('[data-video-template]');
        if (!template) return null;
        const fragment = template.content.cloneNode(true);
        const video = fragment.querySelector('video');
        if (!video) return null;
        const button = card.querySelector('[data-play]');
        const error = card.querySelector('[data-error]');
        video.playsInline = true;
        video.preload = 'auto';
        card.classList.add('has-video');
        const options = { signal: this.controller.signal };
        const stopped = () => {
          if (!video.paused && !video.ended && !video.error) return;
          card.classList.remove('is-playing', 'is-loading');
          card.removeAttribute('aria-busy');
          button.disabled = false;
        };
        const failed = () => {
          card.classList.remove('is-playing', 'is-loading', 'has-frame');
          card.removeAttribute('aria-busy');
          button.disabled = false;
          // Background preparation must not replace the cover with an error.
          // A real play request can retry and report a failure if necessary.
          error.hidden = !this.playRequests.has(video);
        };
        const sources = Array.from(video.querySelectorAll('source'));
        const failedSources = new Set();
        video.addEventListener('loadstart', () => failedSources.clear(), options);
        sources.forEach(source => source.addEventListener('error', () => {
          failedSources.add(source);
          if (failedSources.size === sources.length) failed();
        }, options));
        video.addEventListener('play', () => {
          if (this.cards[this.activeIndex] !== slide || document.hidden) { video.pause(); return; }
          document.dispatchEvent(new CustomEvent('vivelle:spotlight:play', { detail: { video } }));
          error.hidden = true;
        }, options);
        video.addEventListener('playing', () => {
          if (this.cards[this.activeIndex] !== slide || document.hidden) { video.pause(); return; }
          card.classList.remove('is-loading');
          card.classList.add('has-frame', 'is-playing');
          card.removeAttribute('aria-busy');
          error.hidden = true;
          if (document.activeElement === button) video.focus({ preventScroll: true });
        }, options);
        video.addEventListener('pause', stopped, options);
        video.addEventListener('ended', stopped, options);
        video.addEventListener('error', failed, options);
        card.querySelector('[data-media]').append(fragment);
        // Start preparation once, only for a visible selection or an explicit
        // play request. Returning to this card reuses its element and buffer.
        video.load();
        return video;
      }

      playCard(index, autoplay = false) {
        const slide = this.cards[this.normalize(index)];
        const card = slide.querySelector('.vvs__card');
        if (!card.querySelector('[data-video-template]')) return;
        // This synchronous alignment never waits for a timer or transition. The
        // following play() remains inside the visitor's original tap activation.
        if (!autoplay) {
          this.cancelGesture();
          this.resolveCanonical(this.normalize(index), true, false);
        } else if (this.normalize(index) !== this.activeIndex || this.animation || this.gesture || !this.selectedVideoVisible()) return;
        this.autoplayAttemptedIndex = this.activeIndex;
        const video = this.ensureVideo(index);
        if (!video) return;
        const button = card.querySelector('[data-play]');
        const error = card.querySelector('[data-error]');
        const request = (this.playRequests.get(video) || 0) + 1;
        this.playRequests.set(video, request);
        button.disabled = true;
        error.hidden = true;
        card.classList.add('is-loading');
        card.setAttribute('aria-busy', 'true');
        this.pauseVideos(video);
        if (video.error || video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) video.load();
        video.play().catch(playError => {
          if (this.playRequests.get(video) !== request) return;
          button.disabled = false;
          card.classList.remove('is-playing', 'is-loading');
          card.removeAttribute('aria-busy');
          if (playError.name !== 'AbortError' && !(autoplay && playError.name === 'NotAllowedError')) error.hidden = false;
        });
      }

      pauseVideos(except) {
        this.cards?.forEach(card => {
          const video = card.querySelector('video');
          if (video && video !== except) video.pause();
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.visibilityFrame);
        this.cancelGesture();
        this.stopAnimation();
        this.pauseVideos();
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.querySelectorAll('[data-loop-copy]').forEach(copy => copy.remove());
        this.querySelectorAll('[data-media]').forEach(media => media.replaceChildren());
        this.querySelectorAll('.vvs__card').forEach(card => {
          card.classList.remove('has-video', 'has-frame', 'is-loading', 'is-playing');
          card.removeAttribute('aria-busy');
        });
        this.querySelectorAll('[data-play]').forEach(button => { button.disabled = false; });
        if (this.rail) this.rail.style.transform = '';
        this.classList.remove('is-repositioning');
        this.removeAttribute('data-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
